var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDowndrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M6.97278 6.97278L22.5 0.541196L38.0272 6.97278L44.4588 22.5L38.0272 38.0272L22.5 44.4588L6.97278 38.0272L0.541196 22.5L6.97278 6.97278Z",
    stroke: "#FFFCF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6428 21.2144C27.6428 21.2144 26.1428 21.6429 24.8571 22.9286C23.5714 24.2144 22.5 26.3572 22.5 26.3572C22.5 26.3572 21.4285 24.2144 20.1428 22.9286C18.8571 21.6429 17.3571 21.2144 17.3571 21.2144",
    stroke: "#FCD043"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowndrop);
export default __webpack_public_path__ + "static/media/downdrop.1bdc213f7211ca8056659c026974ce16.svg";
export { ForwardRef as ReactComponent };